import { PortalModule } from '@angular/cdk/portal';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ImageModule } from '@com-delta-idp/mnx-ui-kit';
import { MembershipCardComponent } from './membership-card.component';

@NgModule({
  declarations: [MembershipCardComponent],
  imports: [CommonModule, ImageModule, PortalModule],
  exports: [MembershipCardComponent]
})
export class MembershipCardModule {}
